export default `
<svg
  aria-hidden="true"
  aria-label="nav-panel"
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
>
  <rect x="2.5" y="2.5" width="15" height="15" rx="2" stroke="currentColor" stroke-width="1.25" />
  <path d="M8.5 2.5v15" stroke="currentColor" stroke-width="1.25" />
</svg>
`;
